
var Backstage  = window.Backstage || { };
var Cargo = Cargo || { };

_.extend( Backstage.Events = {}, Backbone.Events );

Backstage.View = { };
Backstage.Model = { };
Backstage.Collection = { };

define('main',[
	'_models/default',
	'_views/Spotlight',
	'_views/Messages',
	'_views/Navigation',
	'_views/Fans',
	'_views/Star',
	'_views/Contact',
	'_collections/Fans',
	'_collections/FanOf',
	'_collections/SitesAsEditor',
	'router',
	'_plugins/shortcuts',
	'_plugins/autosize',
],
function(
	DefaultModel,
	SpotlightView,
	MessagesView,
	NavigationView,
	FansView,
	StarView,
	ContactView,
	FanCollection,
	FanOfCollection,
	SitesAsEditorCollection,
	Router
) {

	var MainView = Backbone.View.extend({

		prevent_render: false,

		data : {
			parent: window.parent,
			iframe: false,
			size: null
		},

		el : 'body',

		events : {
			'click [data-destination]' : 'navigate'
		},

		initialize: function() {
			// iFrame check
			if (window.parent !== window) {
				this.data.iframe = true;
			}

			/*
			 * Models and collections
			 */
			Backstage.Model.Default = new DefaultModel();
			Backstage.Model.Default.fetch();
			// Now that we know where we are, set the URL
			Backstage.Model.Default.url = "/_api/v0/site/"+Backstage.Model.Default.get('site_url')+"/fandefaults";
			
			Backstage.Collection.fanCollection = new FanCollection();
			Backstage.Collection.fanOfCollection = new FanOfCollection();
			Backstage.Collection.sitesAsEditorCollection = new SitesAsEditorCollection();

			Backstage.Collection.fanCollection.fetch();
			Backstage.Collection.fanOfCollection.fetch();
			Backstage.Collection.sitesAsEditorCollection.fetch();

			/*
			 * Views
			 */
			Backstage.View.Spotlight = new SpotlightView({ model: Backstage.Model.Default });
			Backstage.View.Messages = new MessagesView({ model: Backstage.Model.Default });
			Backstage.View.Navigation = new NavigationView({ model: Backstage.Model.Default });
			Backstage.View.Fans = new FansView({ model: Backstage.Model.Default });
			Backstage.View.Star = new StarView({ model: Backstage.Model.Default });
			Backstage.View.Contact = new ContactView({ model: Backstage.Model.Default });

			/*
			 * Events
			 */
			Backstage.Events.on('slidepanel:show_contact_form', function(e){
				$('[data-section="contact"]').removeClass('hidden').show();
				Backstage.Router.navigate('contact', true);
				$('#slide-container').addClass('opening');
				$('.persona-tag').hide();
				
				setTimeout(function(){
					$('#slide-container').addClass('open').removeClass('opening');
					Backstage.Events.trigger('slidepanel:open_complete');
				}, 300);
			});

			Backstage.Events.on('slidepanel:close', function(e){
				$('#slide-container').addClass('closing').removeClass('open');
				
				setTimeout(function(){
					$('#slide-container').removeClass('closing');
					Backstage.Events.trigger('slidepanel:close_complete');
				}, 300);
			});

			this.setDomEvents();

			/*
			 * Start the router
			 */
			this.startRouter();

			/*
			 * Do a hard check to the server for updated cookie data
			 * and render this view on success
			 */
			this.listenTo(Backstage.Model.Default, "sync", this.render);
			Backstage.Model.Default.fetch({ reset : true });
		
		},

		render: function() {

			// When updating the default model, sometimes we don't want a full render
			if(this.prevent_render) {
				this.prevent_render = false;
				return;
			}

			if (this.isMobile()) {
				this.$el.addClass('mobile');
			}

			$('#backstage_loading').hide();

			// Render the views
			Backstage.View.Navigation.setElement($('[data-container="navigation"]')).render();
			Backstage.View.Spotlight.setElement($('[data-container="spotlight"]')).render();
			
			if(Backstage.View.Messages.$el.html() == '') {
				Backstage.View.Messages.setElement($('[data-container="messages"]')).render();
			}
			Backstage.View.Fans.setElement($('[data-section="fans-section"]')).render();
			Backstage.View.Star.setElement($('[data-container="star"]')).render();
			Backstage.View.Contact.setElement($('[data-section="contact"]')).render();

			// Re-fetch the editors (cookies may have changed)
			Backstage.Collection.sitesAsEditorCollection.fetch();

			// Do the start route
			Backstage.Router.navigate(this.start_route, { trigger : true, replace : true });

			// Just to be sure
			this.showFirstLoadImages(false);

		},

		/*
		 *
		 * Router
		 * 
		 */
		startRouter: function() {
			// Make and start the router 
			Backstage.Router = new Router();
			Backbone.history.start({
				pushState: true,
				root: '/backstage/' + Backstage.Model.Default.get('site_url')
			});

			// Figure out the start path
			this.start_route = document.location.pathname.split(Backstage.Model.Default.get('site_url'))[1];
			if(this.start_route.charAt(0)=='/') {
				this.start_route = this.start_route.substring(1);
			}

			// Check the route and show contact if needed
			if(this.start_route == "contact") {
				//force contact open
				$('[data-section="contact"]').removeClass('hidden').show();
				$('#slide-container').addClass('open');
				Backstage.Events.trigger('slidepanel:open_complete');
			
			} else {
				Backstage.Events.trigger('slidepanel:close');
			}
		},

		closeBackstage: function() {
			parent.Cargo.View.Backstage.Toggle();
			Backstage.Events.trigger('slidepanel:close');
		},

		/*
		 *
		 * Dom Events
		 * 
		 */
		setDomEvents: function() {
			$(document).on('dragover', function(e){
				e.preventDefault();
			});

			$(document).on('drop', function(e){
				e.preventDefault();
			});
			
			$(document).on('keyup', function(e){
				if(e.keyCode === 27) {
					// esc
					if(parent !== window) {
						if(parent.Cargo.View.Backstage.isActive()) {
							Backstage.View.Main.closeBackstage();
						}
					}
				}
			});

			$(document).on('keypress', function(e){
				if(e.shiftKey === true) {
					if(e.charCode === 65) {
						// shift + a		
						if(parent !== window && e.target.nodeName !== "TEXTAREA" && e.target.nodeName !== "INPUT") {
							window.top.location.href = '/admin';
						}
					} else if(e.charCode === 66) {
						// shift + b
						if(parent !== window && e.target.nodeName !== "TEXTAREA" && e.target.nodeName !== "INPUT") {
							Backstage.View.Main.closeBackstage();
						}
					}
				}
			});
		},

		/*
		 * Global navigation method
		 */
		navigate: function(e) {
			var destination = ($(e.currentTarget).data('destination') == "spotlight") ? '' : '/' + $(e.currentTarget).data('destination');
			Backstage.View.Main.data.parent.Cargo.Event.trigger("add_history", "backstage"+destination);
			return false;
		},

		/**
		 * This method will force show and hidden images in spotlight or messages
		 * It is called by the Backstage.js view from the API
		 */
		showFirstLoadImages: function(force) {

			if(force !== false) {
				force = true;
			}

			Backstage.View.Spotlight.checkAndShowFanImage(force);
			Backstage.View.Messages.checkAndShowMessageImage(force);
		},

		/**
		 *	Test for iOS.
		 *  
		 *  @memberof Cargo.o.Helpers
		 *  @return {boolean}
		 *  @example Cargo.Helper.isIOS();
		 */
		isIOS : function() {
			if (navigator.userAgent.match(/i(Phone|Pod|Pad)/i)) {
				return true;	
			} else {
				return false;
			}
		},

		isMobile : function() {
			if(this.isIOS()) return true
			else {
				var check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
				return check;
			}
		},

	});

	Backstage.View.Main = new MainView();

});

